var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-product"},[_c('ProductMain',{staticClass:"page-product__main",attrs:{"product":_vm.product}}),_vm._v(" "),_c('ProductGallery',{staticClass:"page-product__gallery",attrs:{"product":_vm.product}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }